import { render, staticRenderFns } from "./ThankyouConfirm.vue?vue&type=template&id=33473e2b&scoped=true"
import script from "./ThankyouConfirm.vue?vue&type=script&lang=js"
export * from "./ThankyouConfirm.vue?vue&type=script&lang=js"
import style0 from "./ThankyouConfirm.vue?vue&type=style&index=0&id=33473e2b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33473e2b",
  null
  
)

export default component.exports